import {
  Box,
  Text,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'
export const Card = styled(Box)`
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  gap: ${({ theme }) => getThemeSpacing(3, theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  align-items: center;
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  width: 100%;
  flex-direction: column;
`
export const IconContainer = styled(Box)`
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.input};
  border-radius: 10px;
`

export const Container = styled(Box)`
  flex-wrap: wrap;
  gap: ${({ theme }) => getThemeSpacing(6, theme)};
  row-gap: ${({ theme }) => getThemeSpacing(1, theme)};
`

export const DescriptionText = styled(Text)`
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
